module.exports = __webpack_public_path__ + "static/media/TAPNYSwagDesignLogo.f2909677.jpeg";